import isNumber from 'lodash/isNumber';
export const _isNumber = isNumber;
